import { Component, OnInit } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";
import { AccountService } from "app/_services/account.service";
declare const swal: any;

@Component({
  selector: "app-forgotpassword",
  templateUrl: "./forgotpassword.component.html",
  styleUrls: ["./forgotpassword.component.css"],
})
export class ForgotpasswordComponent implements OnInit {
  forgotPasswordForm: UntypedFormGroup;
  isLoaderResult: boolean;
  constructor(
    private readonly dialogRef: MatDialogRef<ForgotpasswordComponent>,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly accountService: AccountService
  ) {}

  ngOnInit(): void {
    this.initilizeForm();
  }

  initilizeForm() {
    this.forgotPasswordForm = this.formBuilder.group({
      userEmail: [null, [Validators.required]],
    });
  }
  close() {
    this.dialogRef.close();
  }
  

  forgotPassword(): void {
    this.isLoaderResult = true;
    let model = {
      userEmail: this.forgotPasswordForm.value.userEmail,
      requestedBy: this.forgotPasswordForm.value.userEmail,
    };
    this.accountService.forgotPassword2(model).subscribe(
      (data) => {
        this.isLoaderResult = false;
        if (data.didError) {
          this.isLoaderResult = false;
          swal({
            title: "",
            text: data.message,
            type: "error",
            confirmButtonClass: "btn btn-info",
          });
        } else {
          this.isLoaderResult = false;
          swal({
            title: "",
            text: data.message,
            type: "success",
            confirmButtonClass: "btn btn-info",
          });
           this.dialogRef.close();
        }
      },
      (error) => {
        this.isLoaderResult = false;
        if (error) {
          swal({
            title: "",
            text: error.error,
            type: "error",
            confirmButtonClass: "btn btn-info",
          });
        } else {
          swal({
            title: "",
            text: "Somthing went wrong. Please contact admin",
            type: "error",
            confirmButtonClass: "btn btn-info",
          });
        }
      }
    );
  }
}
